'use client'

import { useTranslations } from 'next-intl'
import { useRestaurantCitySearchContext } from '@/features/restaurants/restaurants-city-search/utils/restaurant-city-search-context'
import { cn } from '@/utils/styles/cn'

export const RestaurantCitySearchFiltersOpenNow = () => {
    const {
        query: { openNow },
        setters: { setOpenNow },
    } = useRestaurantCitySearchContext()

    const t = useTranslations()

    const isActive = Boolean(openNow)

    return (
        <button
            type="button"
            onClick={() => setOpenNow(!openNow)}
            aria-pressed={isActive}
            className={cn(
                `flex h-12 shrink-0 items-center rounded-full border px-4 text-label-md
                whitespace-nowrap cursor-pointer select-none webkit-tap-transparent transition-colors
                duration-150`,
                isActive
                    ? 'border-fg-primary bg-bg-neutral-surface text-fg-primary'
                    : 'border-border-primary text-fg-secondary hover:text-fg-primary'
            )}
        >
            {t('restaurants.city.openRestaurantsFilterLabel')}
        </button>
    )
}
